module.exports = __webpack_public_path__ + "img/logo_alaplana.aa3ead02.svg";